import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { convertStringToLowercase } from '../../../../../utils/convertValues';
import { getURLPathname } from '../../../../../utils/parseURL';
import { BedBottomHeaderListItem, BedTopHeaderListItem } from '../../../../lists/items/header';

export const BedsContentDropdown = memo(function MemoizedBedsContentDropdown({ activeMenuContent }) {
  if (!activeMenuContent) {
    return null;
  }

  return (
    <div className="primary-navigation__list">
      <div className="primary-navigation__list-header">
        <p className="primary-navigation__list-header-heading">
          {activeMenuContent?.contentLink?.expanded?.titleTop || ''}
        </p>

        <p className="primary-navigation__list-header-description">
          {activeMenuContent?.contentLink?.expanded?.descriptionTop || ''}
        </p>

        <div className="primary-navigation__list-header-cta">
          <div className="primary-navigation__list-header-buttons">
            {!!activeMenuContent?.contentLink?.expanded?.showAllLinkTop?.url &&
              !!activeMenuContent?.contentLink?.expanded?.showAllLinkTop?.text && (
                <Link
                  to={getURLPathname(activeMenuContent.contentLink.expanded.showAllLinkTop.url)}
                  rel="noreferrer noopener"
                  role="button"
                  tabIndex={0}
                  className="btn btn--primary btn--small"
                  aria-label={convertStringToLowercase(activeMenuContent.contentLink.expanded.showAllLinkTop.text)}
                >
                  <span>{activeMenuContent.contentLink.expanded.showAllLinkTop.text}</span>
                </Link>
              )}

            {!!activeMenuContent?.contentLink?.expanded?.secondaryLinkTop?.url &&
              !!activeMenuContent?.contentLink?.expanded?.secondaryLinkTop?.text && (
                <Link
                  to={getURLPathname(activeMenuContent.contentLink.expanded.secondaryLinkTop.url)}
                  rel="noreferrer noopener"
                  role="button"
                  tabIndex={0}
                  className="btn btn--secondary btn--small"
                  aria-label={convertStringToLowercase(activeMenuContent.contentLink.expanded.secondaryLinkTop.text)}
                >
                  <span>{activeMenuContent.contentLink.expanded.secondaryLinkTop.text}</span>
                </Link>
              )}
          </div>
        </div>
      </div>

      <ul
        className={`primary-navigation__list--count-${activeMenuContent?.contentLink?.expanded?.itemsPerRowTop || 1}`}
        data-items-id={activeMenuContent?.contentLink?.expanded?.id || null}
      >
        {activeMenuContent?.contentLink?.expanded?.subMenusTop.map((item, idx) => (
          <BedTopHeaderListItem
            key={item?.contentLink?.expanded?.id || idx}
            item={item?.contentLink?.expanded || null}
          />
        ))}
      </ul>

      <p className="primary-navigation__list-bottom-title">
        {activeMenuContent.contentLink.expanded.titleBottom || ''}
      </p>

      <ul
        className={`primary-navigation__list--count-${activeMenuContent.contentLink.expanded?.itemsPerRowBottom || 3}`}
        data-items-id={activeMenuContent?.contentLink?.expanded?.id || null}
      >
        {activeMenuContent?.contentLink?.expanded?.subMenusBottom
          .filter(
            (item2) =>
              item2 && Object.prototype.toString.call(item2) === '[object Object]' && Object.keys(item2)?.length > 0
          )
          .map((item2, index2) => {
            const updatedItem = Object.assign({}, item2);

            return (
              <BedBottomHeaderListItem
                key={updatedItem?.contentLink?.expanded?.id || index2}
                item={updatedItem?.contentLink?.expanded || null}
              />
            );
          })}
      </ul>

      <div className="primary-navigation__list-cta">
        <Link
          to={getURLPathname(activeMenuContent.contentLink.expanded.showAllLinkBottom.url || '#')}
          className="btn btn--primary btn--small"
        >
          <span>{activeMenuContent?.contentLink?.expanded?.showAllLinkBottom?.text || ''}</span>
        </Link>
      </div>
    </div>
  );
});

BedsContentDropdown.propTypes = {
  activeMenuContent: PropTypes.object,
  products: PropTypes.array
};
